module.exports = __webpack_public_path__ + "images/tour/lesson_plan_child_boxes_add_lesson-b9b6c891ed694b0bbbef4c2c076dc8eb.gif";